module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Tags")]), _vm._v(" "), _c('div', {
    staticClass: "widget-buttons flex"
  }, [_c('div', {
    staticClass: "input-box",
    staticStyle: {
      "height": "33px",
      "margin-right": "10px",
      "width": "220px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTag),
      expression: "newTag"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Enter Tag..."
    },
    domProps: {
      "value": (_vm.newTag)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newTag = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticStyle: {
      "height": "33px",
      "width": "120px"
    },
    on: {
      "click": function($event) {
        _vm.createTag(_vm.newTag)
      }
    }
  }, [_vm._v("Create Tag")])]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "500px"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.tags), function(tag, key) {
    return _c('tr', {
      key: key
    }, [_c('td', [_vm._v(_vm._s(tag.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(tag.count))]), _vm._v(" "), _c('td', [_c('button', {
      on: {
        "click": function($event) {
          _vm.removeTag(tag.name)
        }
      }
    }, [_vm._v("Remove")])])])
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Tag")]), _vm._v(" "), _c('th', [_vm._v("Count")]), _vm._v(" "), _c('th')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-066f7a91"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/tags.vue
// module id = 622
// module chunks = 1